__turbopack_context__.v({
  "closeAllButton": "positionSection-module-scss-module__jEYASW__closeAllButton",
  "header": "positionSection-module-scss-module__jEYASW__header",
  "headerActions": "positionSection-module-scss-module__jEYASW__headerActions",
  "headerTitle": "positionSection-module-scss-module__jEYASW__headerTitle",
  "historyLink": "positionSection-module-scss-module__jEYASW__historyLink",
  "positionCount": "positionSection-module-scss-module__jEYASW__positionCount",
  "positionLabel": "positionSection-module-scss-module__jEYASW__positionLabel",
  "positions": "positionSection-module-scss-module__jEYASW__positions",
  "signIn": "positionSection-module-scss-module__jEYASW__signIn",
  "wrapper": "positionSection-module-scss-module__jEYASW__wrapper",
});
